import React, { Component, createContext, useEffect, useState } from "react";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import TopNavigation from "./components/topNavigation";
import SideNavigation from "./components/sideNavigation";

import "./index.css";
import TonovaniPage from "./pages/TonovaniPage";
import HomePage from "./pages/HomePage";
import BaleniPage from "./pages/PackagesPage";
import HardenersPage from "./pages/HardenersPage";
import BazePage from "./pages/BazePage";
import CenikPage from "./pages/CenikPage";
import ExportRecepturPage from "./pages/ExportRecepturPage";
import ImportCenPage from "./pages/ImportCenPage";
import ImportRecepturPage from "./pages/ImportRecepturPage";
import KopirovaniRecepturPage from "./pages/KopirovaniRecepturPage";
import LoginPage from "./pages/LoginPage";
import NastaveniPage from "./pages/NastaveniPage";
import OdstinyPage from "./pages/OdstinyPage";
import PigmentyPage from "./pages/PigmentyPage";
import PodporaPage from "./pages/PodporaPage";
import ProdejciPage from "./pages/ProdejciPage";
import RecepturyPage from "./pages/RecepturyPage";
import SlevyPage from "./pages/SlevyPage";
import UzivatelePage from "./pages/UzivatelePage";
import VyrobkyPage from "./pages/ProductsPage";
import VzorkovnicePage from "./pages/VzorkovnicePage";
import AccessDeniedPage from "./pages/AccessDeniedPage"
import { useTranslation } from "react-i18next";
import MainLayout from "./layouts/MainLayout";
import EmptyLayout from "./layouts/EmptyLayout";
import { MainLayoutRoute } from "./layouts/MainLayoutRoute";
import { EmptyLayoutRoute } from "./layouts/EmptyLayoutRoute";
import { apiGetCurrentUser } from "./services/UsersService";
import { useDispatch, useSelector } from "react-redux";
import { userLoginAction } from "./redux/actions";
import { useHistory } from "react-router-dom";
import Notification from "./components/common/Notification";
import NotImplementedPage from "./pages/NotImplementedPage";
import { checkAdditionalRole, checkCrud } from "./helpers/userRolesHelper";
import KopirovaniRecepturReportPage from "./pages/KopirovaniRecepturReportPage";
import MainPageIfToningIsDenied from "./pages/MainPageIfToningIsDenied";
import MainPageIfToningIsBeingLoaded from "./pages/MainPageIfToningIsBeingLoaded";
import MainPageLoadingNeededConfiguration from "./pages/MainPageLoadingNeededConfiguration";
import RecepturyVlastniPage from "./pages/RecepturyVlastniPage";

require("./App.css");

const SESSION_CHECK_INTERVAL_MS = 15000;

const App = () => {
  const { t } = useTranslation();
  const contextLevel = "Retail";
  const dispatch = useDispatch();
  const history = useHistory();
  const [toningPermissionsLoaded, setToningPermissionsLoaded] = useState(false);
  const [canBasis, setCanBasis] = useState(false);
  const [canToning, setCanToning] = useState(false);
  const [canReceipt, setCanReceipt] = useState(false);
  const [canReceiptAdmin, setCanReceiptAdmin] = useState(false);
  const [canCopyReceipts, setCanCopyReceipts] = useState(false);
  const [canCustomReceipts, setCanCustomReceipts] = useState(false);
  const [canProduct, setCanProduct] = useState(false);
  const [canPackage, setCanPackage] = useState(false);
  const [canHardener, setCanHardener] = useState(false);
  const [canPigment, setCanPigment] = useState(false);
  const [canSampleCard, setCanSampleCard] = useState(false);
  const [canColor, setCanColor] = useState(false);
  const [canSeller, setCanSeller] = useState(false);
  const [canUser, setCanUser] = useState(false);
  const [canDiscount, setCanDiscount] = useState(false);
  const [canImportPrices, setCanImportPrices] = useState(false);
  const [canCenik, setCanCenik] = useState(false);
  const [showSessionExpiredPopup, setShowSessionExpiredPopup] = useState(false);

  const userInfo = useSelector((state: any) => state.userInfo);

  const [loadingDataForRoutes, setLoadingDataForRoutes] = useState(true);

  useEffect(() => {
    if (userInfo) {
      setCanBasis(checkCrud('base', 'read', userInfo));
      setCanToning(checkCrud('toning', 'read', userInfo));
      setCanReceipt(checkCrud('receipt', 'read', userInfo));
      setCanCopyReceipts(checkAdditionalRole('copyReceipt', userInfo));
      setCanReceiptAdmin(checkCrud('receipt', 'admin', userInfo));
      setCanCustomReceipts(checkAdditionalRole('customReceipts', userInfo));
      setCanProduct(checkCrud('product', 'read', userInfo));
      setCanPackage(checkCrud('package', 'read', userInfo));
      setCanHardener(checkCrud('hardener', 'read', userInfo));
      setCanPigment(checkCrud('pigment', 'read', userInfo));
      setCanSampleCard(checkCrud('sampleCard', 'read', userInfo));
      setCanColor(checkCrud('color', 'read', userInfo));
      setCanSeller(checkCrud('seller', 'read', userInfo));
      setCanUser(checkCrud('user', 'read', userInfo));
      setCanDiscount(checkCrud('discount', 'read', userInfo));
      setCanImportPrices(checkAdditionalRole('priceList', userInfo));
      setCanCenik(checkAdditionalRole('cenik', userInfo));

      if (checkCrud('toning', 'read', userInfo)) {

        setToningPermissionsLoaded(true);
      }
      else {
        setToningPermissionsLoaded(true);
      }
    }
  }, [userInfo])

  useEffect(() => {
    document.title = 'Teluria IS';

    apiGetCurrentUser()
      .then((responseData) => {
        dispatch(userLoginAction(JSON.stringify(responseData.data)));

        const isAnonymous = responseData?.data?.Anonymous ?? responseData?.data?.anonymous;

        if (isAnonymous) {
          history.push("/login");
        }
      })
      .catch(() => {
        if (window.location.href.indexOf("login") <= 0) {
          window.location.href = "/login";
        }
      });
  }, []);

  useEffect(() => {
    const handleSessionExpired = () => {
      if (window.location.pathname.toLowerCase().indexOf('/login') === 0) {
        return;
      }

      setShowSessionExpiredPopup(true);
    };

    window.addEventListener('session-expired', handleSessionExpired);

    return () => {
      window.removeEventListener('session-expired', handleSessionExpired);
    };
  }, []);

  useEffect(() => {
    if (showSessionExpiredPopup) {
      return;
    }

    if (window.location.pathname.toLowerCase().indexOf('/login') === 0) {
      return;
    }

    let disposed = false;

    const checkSession = async () => {
      if (disposed) {
        return;
      }

      try {
        const responseData = await apiGetCurrentUser();
        const isAnonymous = responseData?.data?.Anonymous ?? responseData?.data?.anonymous;

        if (isAnonymous) {
          setShowSessionExpiredPopup(true);
        }
      }
      catch (ex: any) {
        if (ex?.response?.status === 401) {
          setShowSessionExpiredPopup(true);
        }
      }
    };

    const handleWindowFocus = () => {
      checkSession();
    };

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        checkSession();
      }
    };

    const intervalId = window.setInterval(checkSession, SESSION_CHECK_INTERVAL_MS);
    checkSession();
    window.addEventListener('focus', handleWindowFocus);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      disposed = true;
      window.clearInterval(intervalId);
      window.removeEventListener('focus', handleWindowFocus);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [showSessionExpiredPopup]);

  const redirectToLoginAfterSessionExpired = () => {
    const returnUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    window.location.assign(`/login?returnUrl=${encodeURIComponent(returnUrl)}`);
  };

  return (
    <div>
      <Notification />
      {showSessionExpiredPopup &&
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 9999,
          backgroundColor: 'rgba(0, 0, 0, 0.45)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <div className="card" style={{ maxWidth: '460px', width: '95%' }}>
            <div className="card-header" style={{ fontWeight: 'bold' }}>
              {t('General.SessionExpiredPopup.Title')}
            </div>
            <div className="card-body">
              <p style={{ marginBottom: '16px' }}>
                {t('General.SessionExpiredPopup.Message')}
              </p>
              <button
                type="button"
                className="btn btn-primary"
                onClick={redirectToLoginAfterSessionExpired}
              >
                {t('General.SessionExpiredPopup.LoginAgain')}
              </button>
            </div>
          </div>
        </div>}
      <Router>
        <Switch>
          <EmptyLayoutRoute
            contextLevel={contextLevel}
            path="/login"
            component={LoginPage}
          />

          {<EmptyLayoutRoute
            contextLevel={contextLevel}
            exact
            path="/"
            component={MainPageLoadingNeededConfiguration}
          />}

          {<MainLayoutRoute
            contextLevel={contextLevel}
            exact
            path="/tonovani"
            component={TonovaniPage}
          />}

          <MainLayoutRoute
            contextLevel={contextLevel}
            exact
            path="/noaccess"
            component={AccessDeniedPage}
          />

          <MainLayoutRoute
            contextLevel={contextLevel}
            path="/__*"
            component={NotImplementedPage}
          />

          {canPackage && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/baleni"
            component={BaleniPage}
          />}
          {canHardener && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/tuzidla"
            component={HardenersPage}
          />}
          {canBasis && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/baze"
            component={BazePage}
          />}
          {canCenik && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/cenik"
            component={CenikPage}
          />}
          {canReceiptAdmin &&
            <MainLayoutRoute
              contextLevel={contextLevel}
              path="/exportreceptur"
              component={ExportRecepturPage}
            />}

          {canImportPrices &&
            <MainLayoutRoute
              contextLevel={contextLevel}
              path="/importCen"
              component={ImportCenPage}
            />}

          {canReceiptAdmin &&
            <MainLayoutRoute
              contextLevel={contextLevel}
              path="/importreceptur"
              component={ImportRecepturPage}
            />}

          {canCopyReceipts &&
            <MainLayoutRoute
              contextLevel={contextLevel}
              path="/kopirovanireceptur"
              component={KopirovaniRecepturPage}
            />}
          {canCopyReceipts &&
            <MainLayoutRoute
              contextLevel={contextLevel}
              path="/kopirovanirecepturJobStatus"
              component={KopirovaniRecepturReportPage}
            />}

          <MainLayoutRoute
            contextLevel={contextLevel}
            path="/nastaveni"
            component={NastaveniPage}
          />
          {canColor && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/odstiny"
            component={OdstinyPage}
          />}
          {canPigment && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/pigmenty"
            component={PigmentyPage}
          />}
          <MainLayoutRoute
            contextLevel={contextLevel}
            path="/podpora"
            component={PodporaPage}
          />
          {canSeller && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/prodejci"
            component={ProdejciPage}
          />}
          {canReceipt && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/receptury"
            component={RecepturyPage}
          />}

          {canCustomReceipts && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/vlastnireceptury"
            component={RecepturyVlastniPage}
          />}

          {canDiscount && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/slevy"
            component={SlevyPage}
          />}
          {canToning && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/tonovani"
            component={TonovaniPage}
          />}
          {canUser && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/uzivatele"
            component={UzivatelePage}
          />}
          {canProduct && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/products"
            component={VyrobkyPage}
          />}
          {canSampleCard && <MainLayoutRoute
            contextLevel={contextLevel}
            path="/vzorkovnice"
            component={VzorkovnicePage}
          />}
        </Switch>
      </Router>
    </div>
  );
};

export default App;
